import { Carousel, Container, Row, Col } from "react-bootstrap";
import carruselIni1 from "../../../assets/images/presentacion1.jpg";
import carruselIni2 from "../../../assets/images/presentacion2.jpg";
import carruselIni3 from "../../../assets/images/presentacion3.jpg";
import carruselIni4 from "../../../assets/images/presentacion4.jpg";
import carruselIni5 from "../../../assets/images/presentacion5.jpg";

import MenuInteremedioAcerca from "./menuInteremedioAcerca";
import ExalumnosSection from "./exalumnos/ExAlumnos";
import HorariosSedes from "./horariossedes/horariosSedes";
import Historia from "./historia/historia";
import { HiAcademicCap } from "react-icons/hi";

const images = [
  {
    src: carruselIni1,
    title: "Bienvenidos a Nuestro Colegio",
    text: "Formamos personas con valores y excelencia académica.",
  },
  {
    src: carruselIni2,
    title: "Excelencia Académica",
    text: "Educación de calidad para el futuro de nuestros estudiantes.",
  },
  {
    src: carruselIni3,
    title: " ",
    text: " ",
  },
  {
    src: carruselIni4,
    title: "Inscripciones Abiertas",
    text: "Sé parte de nuestra comunidad educativa.",
  },
  {
    src: carruselIni5,
    title: "Fiesta de las Artes",
    text: "Celebramos el arte y la cultura en nuestro colegio.",
  },
];

function Acerca() {
  return (
    <div className="pb-5">
      {/* Menú de navegación interno */}
      <MenuInteremedioAcerca />

      {/* Título principal */}
      <div className="text-center mt-4 py-4 text-white">
        <h1 className="fw-bold" style={{ letterSpacing: "2px" }}>
          ACERCA DE <span className="text-warning">NUESTRA MISIÓN</span>
        </h1>
      </div>

      {/* Misión institucional */}
      <Container id="mision" className="my-5" data-aos="fade-up">
        <Row className="justify-content-center text-center">
          <HiAcademicCap className="text-success display-4 mb-3" />
          <Col lg={9}>
            <p className="fs-5">
              El colegio Santo Tomás trabaja para que sus graduados sean
              personas libres, conscientes y empáticas, capaces de tomar
              decisiones con responsabilidad y actuar con integridad en una
              sociedad cambiante. Brindamos una educación que estimula la
              reflexión, la creatividad y la autonomía intelectual.
              Fomentamos un ambiente de respeto mutuo, donde las diferencias son
              valoradas como una oportunidad de crecimiento, y el diálogo es la
              base de la convivencia.
            </p>
          </Col>
        </Row>
      </Container>

      {/* Carrusel de imágenes */}
      <div className="w-100" style={{ height: "100vh", overflow: "hidden" }}>
        <Carousel fade interval={4000}>
          {images.map((image, index) => (
            <Carousel.Item key={index}>
              <img
                className="d-block w-100"
                src={image.src}
                alt={`Slide ${index}`}
                style={{ objectFit: "cover", height: "100vh" }}
              />
              <Carousel.Caption className="bg-dark bg-opacity-50 rounded p-3">
                <h3>{image.title}</h3>
                <p>{image.text}</p>
              </Carousel.Caption>
            </Carousel.Item>
          ))}
        </Carousel>
      </div>

      {/* Secciones adicionales */}
      <div id="exalumnos">
        <ExalumnosSection />
      </div>
      <div id="horarios">
        <HorariosSedes />
      </div>
      <div id="historia">
        <Historia />
      </div>
    </div>
  );
}

export default Acerca;
